import { useEffect } from "react";

const SITE_NAME = "JmoLux";

const upsertMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const upsertLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const getCanonicalUrl = (path) => {
  if (typeof window === "undefined") return path || "/";
  return new URL(path || window.location.pathname, window.location.origin).toString();
};

const Seo = ({
  title,
  description,
  path,
  image = "/logo512.png",
  type = "website",
  structuredData,
}) => {
  useEffect(() => {
    const canonical = getCanonicalUrl(path);
    const imageUrl = image.startsWith("http")
      ? image
      : new URL(image, window.location.origin).toString();

    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

    upsertMeta('meta[name="description"]', {
      name: "description",
      content: description,
    });
    upsertMeta('meta[property="og:title"]', {
      property: "og:title",
      content: title ? `${title} | ${SITE_NAME}` : SITE_NAME,
    });
    upsertMeta('meta[property="og:description"]', {
      property: "og:description",
      content: description,
    });
    upsertMeta('meta[property="og:type"]', {
      property: "og:type",
      content: type,
    });
    upsertMeta('meta[property="og:url"]', {
      property: "og:url",
      content: canonical,
    });
    upsertMeta('meta[property="og:image"]', {
      property: "og:image",
      content: imageUrl,
    });
    upsertMeta('meta[name="twitter:card"]', {
      name: "twitter:card",
      content: "summary_large_image",
    });
    upsertMeta('meta[name="twitter:title"]', {
      name: "twitter:title",
      content: title ? `${title} | ${SITE_NAME}` : SITE_NAME,
    });
    upsertMeta('meta[name="twitter:description"]', {
      name: "twitter:description",
      content: description,
    });
    upsertMeta('meta[name="twitter:image"]', {
      name: "twitter:image",
      content: imageUrl,
    });
    upsertLink('link[rel="canonical"]', {
      rel: "canonical",
      href: canonical,
    });

    let structuredDataScript;
    if (structuredData) {
      structuredDataScript = document.getElementById("seo-structured-data");
      if (!structuredDataScript) {
        structuredDataScript = document.createElement("script");
        structuredDataScript.type = "application/ld+json";
        structuredDataScript.id = "seo-structured-data";
        document.head.appendChild(structuredDataScript);
      }
      structuredDataScript.textContent = JSON.stringify(structuredData);
    }

    return () => {
      if (!structuredData) return;
      const script = document.getElementById("seo-structured-data");
      if (script) {
        script.remove();
      }
    };
  }, [description, image, path, structuredData, title, type]);

  return null;
};

export default Seo;
